import { createFileRoute } from "@tanstack/react-router";

import IssueReports from "@/features/issue-reports";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/issues-reports/")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Issues & Reports");

  return <IssueReports />;
}
